module.exports = __webpack_public_path__ + "static/35-7cd02cfefa6a7aa1e21554fa7aafa902.jpg";